<template>
  <div>
    <common-table
      :table-columns="tableColumns"
      :url="url"
      :operate="[]"
      :form-fields="formFields"
      pageName="selectionCartAccount"
      :permission="permission"
      :buttons="[]"
      :searchs="searchs" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable/CommonTable'

export default {
  name: 'SelectionCartAccountList',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId', placeholder: '代理', type: 'select', selectUrl: '/agent/getAll', selectData: []
      }, {
        name: 'name', placeholder: '采集账号/备注', type: 'input'
      }, {
        name: 'enabled', placeholder: '启用状态', type: 'select', selectValue: [
          { key: 1, value: '启用' }, { key: 0, value: '停用' }
        ]
      }],
      permission: { list: 'selectionCartAccount:list' },
      url: { get: '/selectionCartAccount/listByCondition' },
      formFields: { addTitle: '', updateTitle: '', model: [] },
      tableColumns: [{
        field: 'id', label: 'ID', show: true, width: '80'
      }, {
        field: 'accountName', label: '采集账号', show: true
      }, {
        field: 'publishAccountId', label: '发布账号ID', show: true
      }, {
        field: 'userId', label: '用户ID', show: true, width: '100'
      }, {
        field: 'agentId', label: '代理', selectUrl: '/agent/getAll', selectData: [], show: { type: 'select' }
      }, {
        field: 'enabled', label: '启用状态', show: { type: 'tag', tags: [
          { key: 1, value: '启用', type: 'success' }, { key: 0, value: '停用', type: 'info' }
        ] }
      }, {
        field: 'lastCollectAt', label: '最近采集时间', show: true
      }, {
        field: 'lastCollectCount', label: '最近采集数量', show: true
      }, {
        field: 'remark', label: '备注', show: true, detail: true
      }, {
        field: 'createTime', label: '创建时间', show: true
      }]
    }
  }
}
</script>
